export default "__VITE_ASSET__ByqaldlE__"